// extracted by mini-css-extract-plugin
export var cancelButton = "_m5-5";
export var content = "_m5-3";
export var createButton = "_m5-6";
export var drawerContainer = "_m5-0";
export var footer = "_m5-2";
export var header = "_m5-1";
export var orderFormColumn = "_m5-4";